export const googleTranslateCookieName = 'googtrans';
export const PCE_ENABLED_VACCINE_TRANSLATION = 'PCE_EnableVaccineTranslation';

/**
 * @description Used as a classname on an element to ignore translations
 * @type {string}
 */
export const skipTranslation = 'skiptranslate';
